import type { LabelHTMLAttributes } from "react";
import { Checkbox } from "./ui/checkbox";
import { Label } from "./ui/label";
import { cn } from "../lib/utils";

interface Props extends Omit<LabelHTMLAttributes<HTMLLabelElement>, "children"> {
  id: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export function LabeledCheckbox({
  id,
  label,
  checked,
  onChange,
  className,
  htmlFor,
  ...props
}: Props) {
  return (
    <Label
      htmlFor={htmlFor ?? id}
      className={cn(
        "bg-white border rounded-md shadow-sm px-3 py-2 flex items-center gap-2 cursor-pointer mb-0",
        className
      )}
      {...props}
    >
      <Checkbox id={id} checked={checked} onCheckedChange={onChange} />
      {label}
    </Label>
  );
}
